import { map } from 'rxjs/operators';
import { Observable as WindowedObservable } from 'windowed-observable';
export class EsgTransformer {
    constructor(esgApiService, basketDataService, basketDataTransformerService, featureFlagsService) {
        this.esgApiService = esgApiService;
        this.basketDataService = basketDataService;
        this.basketDataTransformerService = basketDataTransformerService;
        this.featureFlagsService = featureFlagsService;
        this.alternatives$ = new WindowedObservable('alternatives$');
    }
    onAlternativeChange(callBack) {
        EsgTransformer.handleCallbackError(callBack);
        return this.alternatives$.subscribe(callBack);
    }
    alternativeChangeUnSubscribe(callBack) {
        EsgTransformer.handleCallbackError(callBack);
        return this.alternatives$.unsubscribe(callBack);
    }
    static handleCallbackError(callBack) {
        if (!callBack) {
            throw new Error('callback function must be provided');
        }
    }
    transformEsgData(portfolioId) {
        if (this.isEsgAlternativesEnabled()) {
            this.esgApiService.getData(portfolioId).subscribe((esgResp) => {
                const alternativeIds = EsgTransformer.retrieveAlternatives(esgResp.data, portfolioId);
                if (alternativeIds && alternativeIds.length > 0) {
                    this.sendAlternativeValues(alternativeIds, portfolioId);
                }
                else {
                    this.emitEmptyAlternatives();
                }
            });
        }
    }
    emitEmptyAlternatives() {
        this.alternatives$.publish(null);
    }
    emitAlternatives(funds, portfolioId) {
        const orderedFunds = EsgTransformer.orderAlternatives(funds);
        this.alternatives$.publish(EsgTransformer.supplyAlternativeData(orderedFunds, portfolioId));
    }
    isEsgAlternativesEnabled() {
        return this.featureFlagsService.isEnabled('FEATURE_ESG_ALTERNATIVES');
    }
    static retrieveAlternatives(esgResp, portfolioId) {
        var _a;
        const products = (_a = esgResp === null || esgResp === void 0 ? void 0 : esgResp.data) === null || _a === void 0 ? void 0 : _a.products;
        if (Array.isArray(products && products[portfolioId] && products[portfolioId].alternatives)) {
            return products[portfolioId].alternatives;
        }
        return [];
    }
    sendAlternativeValues(alternativeIds, portfolioId) {
        this.basketDataService
            .getProductData(alternativeIds)
            .pipe(map((response) => this.basketDataTransformerService.mapApiResponseToBasketItems(response === null || response === void 0 ? void 0 : response.data, alternativeIds)), map((funds) => funds.map((fund, counter) => EsgTransformer.addAlternativeRelatedParams(fund, portfolioId, counter))))
            .subscribe((funds) => {
            this.emitAlternatives(funds, portfolioId);
        });
    }
    static addAlternativeRelatedParams(fund, portfolioId, counter) {
        return Object.assign(Object.assign({}, fund), { inactivated: true, isAlternative: true, nonSustainableId: portfolioId, alternativeOrder: counter });
    }
    static supplyAlternativeData(funds, portfolioId) {
        return {
            nonSustainableId: portfolioId,
            alternatives: funds,
        };
    }
    static orderAlternatives(funds) {
        funds.sort((a, b) => a.alternativeOrder - b.alternativeOrder);
        return funds;
    }
}
